var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"a_right"},[(_vm.$route.path != '/info')?_c('page-header',{ref:"header"}):_vm._e(),_c('div',{staticClass:"main-content"},[_c('router-view',{ref:"main"})],1),_c('page-footer')],1),_c('member-info-modal',{attrs:{"memberKey":_vm.memberKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }